import React from 'react';
import './style.scss';

interface PropsType {
    type?: string;
    placeholder?: string;
    text: string | number;
    setText: (text: string | number) => void;
}

const AfInput = ({ text, setText, type = 'text', placeholder }: PropsType) => {
    return <input className="af-input" onChange={({ target }) => setText(target.value)} placeholder={placeholder} type={type} value={text} />;
};

export default AfInput;
